import {ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  Jaarrekening, Jaarrapportage
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil} from "rxjs";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-toelichting-overige-toelichtingen-winst-en-verliesrekening',
  templateUrl: './toelichting-overige-toelichtingen-winst-en-verliesrekening.component.html',
  imports: [
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./toelichting-overige-toelichtingen-winst-en-verliesrekening.component.css']
})
export class ToelichtingOverigeToelichtingenWinstEnVerliesrekeningComponent implements OnInit {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public otherNotesIncomeStatementFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.otherNotesIncomeStatementFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const overigeToelichtingenWinstEnVerliesrekening = value.rapportage?.jaarrekeningen?.at(0)?.toelichting?.toelichtingWinstEnVerliesrekening?.overigeToelichtingenWinstEnVerliesrekening;

    if (overigeToelichtingenWinstEnVerliesrekening) {
      if (overigeToelichtingenWinstEnVerliesrekening.overigeToelichtingen?.otherNotesIncomeStatement) {
        this.otherNotesIncomeStatementFg.patchValue(overigeToelichtingenWinstEnVerliesrekening.overigeToelichtingen?.otherNotesIncomeStatement);
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });

    this.otherNotesIncomeStatementFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        toelichting: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting,
          toelichtingWinstEnVerliesrekening: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.toelichtingWinstEnVerliesrekening,
            overigeToelichtingenWinstEnVerliesrekening: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.toelichtingWinstEnVerliesrekening?.overigeToelichtingenWinstEnVerliesrekening,
              overigeToelichtingen: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.toelichtingWinstEnVerliesrekening?.overigeToelichtingenWinstEnVerliesrekening?.overigeToelichtingen,
                otherNotesIncomeStatement: this.otherNotesIncomeStatementFg.value
              }
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
  }
}

